import http from '@/utils/http'

export function addSubscription(data){
    return http.post('/subscriptions',data)
}
export function putSubscription(id,data){
    return http.put(`/subscriptions/${id}`,data)
}

export function subscriptionUpgradeRequest(id,data){
    return http.post(`/subscriptions/${id}/upgrade_request`,data)
}